export default __webpack_public_path__ + "static/media/S_wdt_c_cap_1.826cff7d.mp3";